<template>

    <span>
    <v-layout mb-4>
      <v-flex xs10 ml-3>
        <h2 class="lime--text lighten-1 pt-3">Gerenciar Setor Banner - Inclusão</h2>
      </v-flex>
      <v-flex xs2 text-right mr-3>
        <v-btn
          color="blue-grey"
          class="black--text"
          :to="{name: 'bannersector'}"
        >
          <v-icon dark>keyboard_arrow_left</v-icon>
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>
        <form-banner-sector :btnLabel="btnLabel"></form-banner-sector>
    </span>
        
</template>

<script>
import FormBannerSectorComponent from "./partial/FormBannerSectorComponent";

export default {
  name: "AddBannerSectorComponent",
  data () {
    return {
        btnLabel: 'Incluir'
    }
  },
  methods: {

  },
  components: {
    formBannerSector: FormBannerSectorComponent,
  }
};
</script>

<style scoped>

</style>
